import React from "react";
import styled from "styled-components";
import PrivateOrBusiness from "./private-business";

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
`;
const Wrapper = styled.div`
  width: 100%;
  min-height: 40%;
  max-width: 700px;
  background: var(--color-white);
  position: relative;
  margin: 0 auto;
  top: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const InnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 350px;
`;
const Title = styled.h1`
  width: 100%;
  text-align: center;
  margin-block: 1rem;
`;

const PrivateOrBusinessPopUp = () => {
  return (
    <Background>
      <Wrapper>
        <InnerWrapper>
          <Title>Epoxygrossisten</Title>
          <PrivateOrBusiness $isPopUp={true} />
        </InnerWrapper>
      </Wrapper>
    </Background>
  );
};

export default PrivateOrBusinessPopUp;
